import { EcommerceTrackingData } from "./ecommerce-tracking-data.class";
export class ScholarshipCardImpressionData extends EcommerceTrackingData {
    productId;
    bodyId;
    listPageType;
    listName;
    organisationId;
    disciplines;
    premium;
    listPosition;
    unitPrice;
    currency;
    constructor(productId, bodyId, listPageType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency) {
        super(productId, listPageType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency);
        this.productId = productId;
        this.bodyId = bodyId;
        this.listPageType = listPageType;
        this.listName = listName;
        this.organisationId = organisationId;
        this.disciplines = disciplines;
        this.premium = premium;
        this.listPosition = listPosition;
        this.unitPrice = unitPrice;
        this.currency = currency;
    }
    getTrackingContext() {
        return {
            organisationId: this.getOrganisationId(),
            studyId: undefined,
            scholarshipId: this.getProductId(),
            bodyId: this.bodyId,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: this.getUnitPrice(),
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
